// extracted by mini-css-extract-plugin
module.exports = {"menuDesktop":"hnnc7p","menuMobile":"kN1OXG"};